import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// users
import user1 from "../../../assets/images/avatar.png";
import { selectUser } from "store/features/auth/authSlice";
import { selectCurrentCRM } from "store/features/users/userSlice";
import { useGetUserQuery } from "store/features/users/userManagementApi";

const ProfileMenu = props => {
  const user = useSelector(selectUser);
  const { data: apiUser } = useGetUserQuery(user?.id, { skip: !user?.id });
  const currentUser = apiUser || user;

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const [username, setusername] = useState("Admin");

  const currentCRM = useSelector(selectCurrentCRM);

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      try {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        if (obj?.displayName) setusername(obj.displayName);
        else if (obj?.username) setusername(obj.username);
        else if (obj?.first_name) setusername(`${obj.first_name} ${obj.last_name || ''}`);
      } catch (e) {}
    }
  }, [props.success]);

  // Determine avatar image source
  const getAvatarSrc = () => {
    const rawImg = currentUser?.image || currentUser?.profile_image || currentUser?.photo || currentUser?.avatar || currentUser?.user_info?.image || currentUser?.user_info?.profile_image;
    if (!rawImg) return user1;

    if (typeof rawImg === "string") {
      if (rawImg.startsWith("http://") || rawImg.startsWith("https://") || rawImg.startsWith("data:")) {
        return rawImg;
      }
      const apiBase = process.env.REACT_APP_API_URL || "http://localhost:8000";
      const cleanBase = apiBase.endsWith("/") ? apiBase.slice(0, -1) : apiBase;
      const cleanPath = rawImg.startsWith("/") ? rawImg : `/${rawImg}`;
      return `${cleanBase}${cleanPath}`;
    }
    return user1;
  };

  const displayName = currentUser?.nickname || currentUser?.first_name || currentUser?.name || currentUser?.username || username || "User";
  const userRole = currentUser?.role || (currentUser?.is_superuser ? "Super Admin" : "Team Member");
  const avatarSrc = getAvatarSrc();

  return (
    <React.Fragment>
      {currentCRM !== "qwik_bistro" && (
        <Dropdown
          isOpen={menu}
          toggle={() => setMenu(!menu)}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item waves-effect d-flex align-items-center border-0 px-2"
            id="page-header-user-dropdown"
            tag="button"
          >
            <img
              className="rounded-circle me-2 shadow-sm"
              src={avatarSrc}
              alt={displayName}
              onError={(e) => { e.target.onerror = null; e.target.src = user1; }}
              style={{
                width: "36px",
                height: "36px",
                objectFit: "cover",
                border: "2px solid #e2e8f0"
              }}
            />
            <div className="d-none d-xl-inline-block text-start me-1">
              <span className="fw-semibold text-dark fs-13 d-block leading-tight">{displayName}</span>
              <span className="text-muted fs-11 text-capitalize d-block">{userRole}</span>
            </div>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block text-muted ms-1" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end shadow-lg border-0 rounded-3">
            <DropdownItem tag="a" href="/profile">
              <i className="mdi mdi-account-circle font-size-17 align-middle me-2 text-primary" />
              {props.t("Profile")}
            </DropdownItem>
            <div className="dropdown-divider" />
            <Link to="/logout" className="dropdown-item text-danger">
              <i className="bx bx-power-off font-size-17 align-middle me-2 text-danger" />
              <span>{props.t("Logout")}</span>
            </Link>
          </DropdownMenu>
        </Dropdown>
      )}

    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
